import { render, staticRenderFns } from "./TopBar.vue?vue&type=template&id=4428f25c&scoped=true"
import script from "./TopBar.vue?vue&type=script&lang=js"
export * from "./TopBar.vue?vue&type=script&lang=js"
import style0 from "./TopBar.vue?vue&type=style&index=0&id=4428f25c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4428f25c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4428f25c')) {
      api.createRecord('4428f25c', component.options)
    } else {
      api.reload('4428f25c', component.options)
    }
    module.hot.accept("./TopBar.vue?vue&type=template&id=4428f25c&scoped=true", function () {
      api.rerender('4428f25c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/file-browser-product-selector/TopBar.vue"
export default component.exports